import React from "react";

const DeviderBorder = () => {
  return (
    <div className="w-full h-px bg-[repeating-linear-gradient(to_right,#d1d5db_0_8px,transparent_8px_14px)] opacity-80"></div>
  );
};

export default DeviderBorder;
